import { PinnedAgent } from '@/types/agents';

/**
 * Rota da interface de um agente por tipo (J05, gotcha §62): o assistente (GENERAL)
 * abre em /assistente/{id}; os agentes do Hub (RAG/SQL) abrem no chat do Hub /agentes/{id}.
 *
 * Sempre por id pro GENERAL: há mais de um assistente GLOBAL (H.Bot, H.Slides) — rotear
 * pra `/assistente` sem id resolveria SEMPRE no primário (H.Bot). `/assistente/{id}`
 * resolve o assistente certo, e funciona até pro H.Bot (que casa pelo próprio id).
 */
export function routeForAgent(type: PinnedAgent['type'], agentId: string): string {
  return type === 'GENERAL' ? `/assistente/${agentId}` : `/agentes/${agentId}`;
}
